
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ping",
      function () {
        return require("private-next-pages/ping.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ping"])
      });
    }
  